var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"view"},[_c('CryptWitAction')],1),_c('div',{staticClass:"table"},[_c('Crypwittable',{key:_vm.$route.params.target})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }